import React from "react";
import { EmptyStateProps } from "../../types";

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title = "No data available",
  description,
  action,
  size = "md",
  className = "",
}) => {
  const sizeClasses = {
    sm: "h-32",
    md: "h-64",
    lg: "h-96",
  };

  const iconSizes = {
    sm: "h-8 w-8",
    md: "h-12 w-12",
    lg: "h-16 w-16",
  };

  const textSizes = {
    sm: "text-sm",
    md: "text-lg",
    lg: "text-xl",
  };

  return (
    <div
      className={`flex items-center justify-center ${sizeClasses[size]} text-muted-foreground ${className}`}
    >
      <div className="text-center">
        {Icon && (
          <Icon className={`${iconSizes[size]} mx-auto mb-4 opacity-50`} />
        )}
        <p className={`${textSizes[size]} font-medium`}>{title}</p>
        {description && <p className="text-sm mt-2">{description}</p>}
        {action && (
          <button
            onClick={action.onClick}
            className="mt-4 px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm hover:bg-primary/90 transition-colors"
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
};
